import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import jsonData from "../../../../current-survey-numeric.json";

const engagementGroups = {
  Recognition: ["MQ0053", "MQ0171", "MQ0103"],
  Autonomy: ["MQ0071", "MQ0202", "MQ0027"],
  Meaningfulness: ["MQ0023", "MQ0024", "MQ0026"],
  Growth: ["MQ0064", "MQ0062", "MQ0043"],
  Teamwork: ["MQ0340", "MQ0341", "MQ0094"],
};

const Heatmap3 = ({ selectedDemographic, filterCriteria }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    // Filter data based on criteria
    const filteredData = jsonData.filter((item) =>
      Object.keys(filterCriteria).every((key) =>
        filterCriteria[key].length === 0
          ? true
          : filterCriteria[key].includes(item[key])
      )
    );

    // Get unique demographic values, replacing null/undefined with "Unknown"
    const demographicValues = [
      ...new Set(
        filteredData.map((item) => item[selectedDemographic] || "Unknown")
      ),
    ].sort();

    // Prepare series data for each engagement group
    const seriesData = Object.keys(engagementGroups).map((group) => {
      const groupData = demographicValues.map((value) => {
        const responses = filteredData.filter(
          (item) => (item[selectedDemographic] || "Unknown") === value
        );

        // Calculate average score for the group
        const scores = responses.map(
          (response) =>
            engagementGroups[group].reduce(
              (acc, question) => acc + (parseFloat(response[question]) || 0),
              0
            ) / engagementGroups[group].length
        );

        const averageScore = scores.length
          ? scores.reduce((acc, score) => acc + score, 0) / scores.length
          : 0;

        return {
          x: value,
          y: isNaN(averageScore) ? 0 : averageScore.toFixed(1),
        };
      });

      return { name: group, data: groupData };
    });

    setChartData(seriesData);
  }, [selectedDemographic, filterCriteria]);

  const options = {
    chart: {
      type: "heatmap",
      toolbar: {
        show: false,
        tools: {
          download: true,
        },
      },
    },
    plotOptions: {
      heatmap: {
        shadeIntensity: 0.5,
        colorScale: {
          ranges: [
            { from: 0, to: 2.99, color: "#e6ffe6", name: "Very Low 0-2.99" },
            { from: 3.0, to: 3.49, color: "#b3ffb3", name: "Low 3-3.49" },
            { from: 3.5, to: 3.99, color: "#66ff66", name: "Medium 3.5-3.99" },
            { from: 4, to: 4.49, color: "#33cc33", name: "High 4-4.49" },
            { from: 4.5, to: 5, color: "#008000", name: "Very High 4.5-5" },
          ],
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#000"],
      },
      formatter: (val) => (isNaN(val) ? "0.0" : val.toFixed(1)),
    },
    xaxis: {
      labels: {
        style: {
          colors: "#6d6d6d",
          fontSize: "0.8rem",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#6d6d6d",
          fontSize: "0.8rem",
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} (Avg)`,
      },
    },
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Chart
        options={options}
        series={chartData}
        type="heatmap"
        height="100%"
      />
    </div>
  );
};

export default Heatmap3;
